export default "__VITE_ASSET__DOXgz6n___"